const JSARLoaderStatus = {
  LOADING: 'loading',
  NOT_AVAILABLE: 'not-available',
  AVAILABLE: 'available'
}

class JSARLoader {
  constructor () {
    this.completed = false
    this.tryCam()
  }
  tryCam () {
    if (navigator.mediaDevices) {
      if (typeof navigator.mediaDevices.getUserMedia === 'function') {
        this.webcamAvailable()
      } else {
        this.webcamNotAvailable()
      }
    } else {
      this.webcamNotAvailable()
    }
  }
  webcamAvailable () {
    this.loadJSAR()
  }
  webcamNotAvailable () {
    this.status = JSARLoaderStatus.NOT_AVAILABLE
    this.completed = true
    this.available = false
  }
  loadScript (src) {
    let head = document.getElementsByTagName('head')[0]
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    script.onreadystatechange = this.loadJSARCheck
    script.onload = this.loadJSARCheck
    script.onerror = this.loadJSARError
    head.appendChild(script)
  }
  loadJSAR () {
    this.status = JSARLoaderStatus.LOADING
    this.loadScript('/js/JSARToolKit.min.js')
    this.loadScript('/js/magi.js')
  }
  loadJSARCheck () {
    if (window.Magi && (typeof window.FLARSingleMarkerDetector === 'function')) {
      loader.completed = true
      loader.available = true
      loader.status = JSARLoaderStatus.AVAILABLE
    }
  }
  loadJSARError () {
    loader.completed = true
    loader.available = false
    loader.status = JSARLoaderStatus.NOT_AVAILABLE
  }
}

const loader = new JSARLoader()

export default {
  loader,
  statusOptions: JSARLoaderStatus
}
